import { z } from "zod"

import { hasValue } from "@/helpers/typeguards"

const idSchema = z.guid()

// No global! https://stackoverflow.com/a/11727400
const caseIdRegexp =
  /^(?<campaign>.*)-(?<studentId>[\w]{8}-[\w]{4}-[\w]{4}-[\w]{4}-[\w]{12})$/
const caseIdSchema = z.string().regex(caseIdRegexp)

const connectUserIdSchema = z.union([idSchema, z.literal("system")])

// TODO: we may not need this abstraction
const datetimeSchema = z.coerce.date()

// We can't just use `.optional()` because `coerce` would return `1970 Jan 1st` for empty values
// so we use `nullish` and add a `transform` step to filter out `null` dates
const optionalDateTimeSchema = z.preprocess(
  (value) => value || undefined,
  z.coerce.date().optional(),
)

const callDurationDataSchema = z.object({
  contact_id: idSchema,
  call_start_timestamp: z.iso.datetime(),
  call_end_timestamp: z.iso.datetime().nullable(),
})

type CallDurationData = z.infer<typeof callDurationDataSchema>

const getCaseParamsSchema = z
  .object({
    student_id: idSchema.nullish().transform((value) => value ?? undefined),
    phone_number: z
      .string()
      .min(1)
      .nullish()
      .transform((value) => value ?? undefined),
    campaign_id: z.string().min(1),
  })
  .refine(
    ({ campaign_id, phone_number, student_id }) => {
      const isValidTaskQuery = hasValue(campaign_id) && hasValue(student_id)
      const isValidVoiceCallQuery =
        hasValue(campaign_id) && hasValue(phone_number)

      return isValidTaskQuery || isValidVoiceCallQuery
    },
    {
      error: "Must have a valid combination of query parameters",
    },
  )

type GetCaseParams = z.infer<typeof getCaseParamsSchema>

export {
  type CallDurationData,
  callDurationDataSchema,
  caseIdRegexp,
  caseIdSchema,
  connectUserIdSchema,
  datetimeSchema,
  type GetCaseParams,
  getCaseParamsSchema,
  idSchema,
  optionalDateTimeSchema,
}
